import { Component, OnInit, ViewChild } from '@angular/core';
import { CroudComponent } from '../liste-prix/croud-liste-prix/croud.component';

@Component({
  selector: 'app-comptable-parametre',
  templateUrl: './comptable-parametre.component.html',
  styleUrls: ['./comptable-parametre.component.scss']
})
export class ComptableParametreComponent implements OnInit {
@ViewChild('croud') croudComponent!: CroudComponent;
  constructor() { }

  ngOnInit(): void {
  }
selectedOrg: string | null = 'org1';

  selectCard(orgId: string) {
    this.selectedOrg = orgId;
  }
}
